import styled, { css } from 'styled-components';
import { ThemeColor } from './types';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
`;

interface ActionButtonProps {
  backgroundColor?: ThemeColor;
  isFirst?: boolean;
  isLast?: boolean;
}

// Função auxiliar para processar a cor de fundo
const getBackgroundColor = (backgroundColor?: ThemeColor, theme?: any) => {
  if (!backgroundColor) {
    return theme?.primaryColor || 'rgb(40, 96, 144)';
  }

  if (typeof backgroundColor === 'function') {
    return backgroundColor(theme);
  }

  return backgroundColor;
};

export const ActionButton = styled.button<ActionButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  padding: 0;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.2s ease, filter 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: ${({ backgroundColor, theme }) =>
    getBackgroundColor(backgroundColor, theme)};
  color: white;

  ${({ isFirst }) => isFirst && css`
    border-radius: 5px 0 0 5px;
  `}

  ${({ isLast }) => isLast && css`
    border-radius: 0 5px 5px 0;
  `}

  &&:hover {
    background-color: ${({ backgroundColor, theme }) =>
      getBackgroundColor(backgroundColor, theme)};
    filter: brightness(0.85);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &&:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    filter: none;
    box-shadow: none;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
